module.exports = __webpack_public_path__ + "static/media/icon-login.2ef8129e.svg";